<div class="all-data-filter-dialog-button"
  [class.all-data-filter-dialog-button_active]="isFilled"
>
  <mat-icon
    (click)="openFilterPopup($event)"
  >
    filter_alt
  </mat-icon>
</div>
